import React, { useState } from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    Card,
    CardContent,
    Alert,
    useTheme,
    useMediaQuery
} from "@mui/material";

import Map from "@mui/icons-material/Map";

import globalPlan from "assets/img/roomsLocations/global_plan.png";

const StayPepinierePlan: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));



    return (
        <>
            <Container maxWidth="md" sx={{ mb: 4 }}>
                <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <Map sx={{ mr: 2, color: 'primary.main', fontSize: 30 }} />
                            <Typography variant="h5">Plan du Domaine de la Pépinière</Typography>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <img
                                src={globalPlan}
                                alt="Plan global"
                                style={{
                                    borderRadius: 3,
                                    width: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </Box>

                    </Box>
                </Paper>
            </Container>

        </>
    );
};

export default StayPepinierePlan;
